(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["demande-devis"] && !Shopify.designMode) return;
  try {
    
  const { createApp, ref, nextTick, onMounted, watch } = Vue;

  createApp({
    delimiters: ['${', '}'],
    setup() {
      const processing = ref(false);
      const assetUrl = ref('');
      const all_datas = ref(null);
      const ordered_datas = ref(null);
      const delai = ref(null);
      const no_logo = ref(false);
      const logo_error = ref(null);
      const logo = ref(null);
      const form_ref = ref(null);
      const form_error = ref(null);
      const customer_details = ref({
        nom: '',
        societe: '',
        telephone: '',
        email: '',
        demande: '',
      });

      onMounted(() => {
        initialSetup();
      });

      const getAssetUrl = (name) => {
        let newUrl = assetUrl.value.replace(
          '/file-name?',
          '/devis_' +
            name
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '')
              .replace(/\s+/g, '-') +
            '.svg?',
        );
        return newUrl;
      };

      const initialSetup = async () => {
        processing.value = true;
        console.log('Setup en cours...');

        const file_url = document.getElementById('master-url').value;
        assetUrl.value = document.getElementById('asset-url').value;

        try {
          const response = await fetch(file_url);
          if (!response.ok) {
            throw new Error('Erreur réseau lors de la tentative de récupération du fichier CSV');
          }

          const data = await response.text();

          // Diviser le CSV en lignes
          const allLines = data.split(/\r\n|\n/);

          // Ignorer la première ligne et extraire les données restantes
          const dataWithoutHeader = allLines.slice(1);

          // Utiliser map pour séparer chaque ligne en cellules
          const result = dataWithoutHeader.map((line) => {
            const regex = /("([^"]*)")|([^,]+)/g;
            const result = [];
            let match;

            while ((match = regex.exec(line)) !== null) {
              // Si le match 2 est défini, c'est une valeur entre guillemets
              if (match[2]) {
                result.push(match[2].trim());
              } else if (match[3]) {
                // Sinon, c'est une valeur non entourée de guillemets
                result.push(match[3].trim());
              }
            }

            return result;
          });

          // Afficher ou traiter le tableau résultant
          all_datas.value = result;
          processing.value = false;
        } catch (error) {
          processing.value = false;
          console.error('Erreur de lecture du fichier CSV:', error);
        }
      };

      const slugify = (string) => {
        return string
          .toLowerCase() // Convertir en minuscules
          .trim() // Supprimer les espaces en début et fin de chaîne
          .replace(/[\s_]+/g, '-') // Remplacer les espaces et underscores par des tirets
          .replace(/[^\w\-]+/g, '') // Supprimer tous les caractères non-alphanumériques sauf les tirets
          .replace(/\-\-+/g, '-'); // Remplacer les tirets multiples par un seul tiret
      };

      watch(all_datas, (newData) => {
        if (!newData) return;
        let tmp = [];

        const products_arr = Array.from(new Set(newData.map((item) => item[1])));
        products_arr.forEach((product) => {
          let tmp_product = {
            name: product,
            slug: slugify(product),
            selection: {
              qty: 0,
              modele: 'basique',
              selected: false,
              active: true,
              emplacement: 'default',
              impression: 'default',
            },
          };

          const corresponding_lines = newData.filter((item) => item[1] == product);
          const emplacements = Array.from(
            new Set(corresponding_lines.filter((item) => item[0] == 'Oui').map((item) => item[2])),
          );
          tmp_product.emplacements = emplacements;
          tmp_product.selection.emplacement = emplacements[0];

          const impressions = Array.from(
            new Set(corresponding_lines.filter((item) => item[0] == 'Oui').map((item) => item[4])),
          );
          tmp_product.impressions = impressions;
          tmp_product.selection.impression = impressions[0];

          tmp = [...tmp, tmp_product];
        });

        ordered_datas.value = tmp;
      });

      watch(no_logo, (newLogo) => {
        if (newLogo && document.getElementById('devis_logo_input')) {
          document.getElementById('devis_logo_input').value = null;
          logo.value = null;
        }
      });

      const updateSelection = (slug, type, value) => {
        console.log(slug, type, value);
      };

      const getProductPrice = (slug, modele, display) => {
        let ref = ordered_datas.value.find((item) => item.slug == slug);
        let product = null;
        let tmp = [...all_datas.value];
        let products = tmp.filter(
          (item) =>
            item[5] == delai.value &&
            item[1] == ref.name &&
            item[2] == ref.selection.emplacement &&
            item[4] == ref.selection.impression,
        );
        products.forEach((item) => {
          let qty_field = item[3].split(' à ');
          let min = parseInt(qty_field[0]);
          let max = qty_field[1] ? parseInt(qty_field[1]) : null;
          if ((ref.selection.qty >= min && ref.selection.qty <= max) || (!max && ref.selection.qty >= min))
            product = item;
        });

        if (product && modele == 1 && display == 'full') {
          let final_price = parseFloat(product[9].replace(',', '.')) * ref.selection.qty;
          return final_price.toFixed(2).replace('.', ',') + ' €';
        }
        if (product && modele == 1 && display == 'min') return product[9].replace('€', '').trim();
        if (product && modele == 1 && display == 'max') return product[10];

        if (product && modele == 2 && display == 'full') {
          let final_price = parseFloat(product[11].replace(',', '.')) * ref.selection.qty;
          return final_price.toFixed(2).replace('.', ',') + ' €';
        }
        if (product && modele == 2 && display == 'min') return product[11].replace('€', '').trim();
        if (product && modele == 2 && display == 'max') return product[12];

        if (product && modele == 3 && display == 'full') {
          let final_price = parseFloat(product[13].replace(',', '.')) * ref.selection.qty;
          return final_price.toFixed(2).replace('.', ',') + ' €';
        }
        if (product && modele == 3 && display == 'min') return product[13].replace('€', '').trim();
        if (product && modele == 3 && display == 'max') return product[14];

        return null;
      };

      const getProductModele = (slug, modele) => {
        let ref = ordered_datas.value.find((item) => item.slug == slug);
        let product = null;
        let tmp = [...all_datas.value];
        let products = tmp.filter(
          (item) =>
            item[5] == delai.value &&
            item[1] == ref.name &&
            item[2] == ref.selection.emplacement &&
            item[4] == ref.selection.impression,
        );
        products.forEach((item) => {
          let qty_field = item[3].split(' à ');
          let min = parseInt(qty_field[0]);
          let max = qty_field[1] ? parseInt(qty_field[1]) : null;
          if ((ref.selection.qty >= min && ref.selection.qty <= max) || (!max && ref.selection.qty >= min))
            product = item;
        });

        if (product && modele == 1) return product[6];
        if (product && modele == 2) return product[7];
        if (product && modele == 3) return product[8];
        return null;
      };

      const handleLogoChange = (e) => {
        no_logo.value = null;
        logo_error.value = null;
        const fileInput = e.target; // L'élément input qui a déclenché l'événement
        const file = fileInput.files[0]; // Le fichier sélectionné

        if (file) {
          const fileType = file.type;
          const fileSize = file.size;
          const maxSizeInBytes = 10 * 1024 * 1024; // 10MB en octets

          const allowedExtensions = ['ai', 'svg', 'png'];
          const fileExtension = fileInput.value.split('.').pop().toLowerCase();
          // Vérifier si le fichier est un PDF
          if (!allowedExtensions.includes(fileExtension)) {
            logo_error.value = 'Le fichier doit être au format .ai, .svg ou .png';
            fileInput.value = ''; // Effacer la sélection de fichier
            logo.value = null;
            console.log('error : logo fileType');
            return; // Sortir de la fonction
          }

          // Vérifier si la taille du fichier ne dépasse pas 10MB
          if (fileSize > maxSizeInBytes) {
            logo_error.value = 'La taille du fichier ne doit pas dépasser 10MB';
            fileInput.value = ''; // Effacer la sélection de fichier
            logo.value = null;
            return; // Sortir de la fonction
          }

          logo.value = file.name;
          console.log('Le fichier est valide !');
        } else {
          logo.value = null;
        }
      };

      const handleCheckValidity = (step) => {
        form_ref.value.reportValidity();
        if (form_ref.value.checkValidity()) nextstep(step);
      };

      const handleSubmit = () => {
        processing.value = true;

        let form_data = new FormData(form_ref.value);
        form_data.append('to', 'contact@lesuperatelier.fr');
        form_data.append('subject', 'Demande de devis : ' + customer_details.value.societe);

        fetch('https://www.p-a-m.cool/projects/lesuperatelier.fr/', {
          body: form_data,
          method: 'POST',
        })
          .then((response) => {
            processing.value = false;
            return response.text();
          })
          .then((data) => {
            if (data == 'fail') {
              form_error.value = true;
            } else {
              nextstep(6);
              showHeader();
            }
          })
          .catch((error) => {
            form_error.value = true;
            console.log('ERROR MAIL : Oops');
          });
      };

      return {
        processing,
        delai,
        ordered_datas,
        updateSelection,
        getProductPrice,
        no_logo,
        logo,
        handleLogoChange,
        logo_error,
        form_ref,
        customer_details,
        handleCheckValidity,
        getProductModele,
        handleSubmit,
        form_error,
        getAssetUrl,
        assetUrl,
      };
    },
    methods: {
      randomizePangram() {
        console.log('oui');
      },
    },
  }).mount('#demande-devis');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"] && !Shopify.designMode) return;
  try {
    
  const { createApp, ref, nextTick, watch, onMounted, getCurrentInstance } = Vue;

  var cartApp;

  function mountCartApp(company_default = '', vat_default = '') {
    cartApp = createApp({
      delimiters: ['${', '}'],
      setup() {
        const company = ref(company_default);
        const vat = ref(vat_default);
        const processing = ref(false);

        function handleCopy(id) {
          var copyText = document.getElementById('share_link');
          copyText.readOnly = true;
          copyText.type = 'text';
          copyText.select();
          copyText.setSelectionRange(0, 99999);
          navigator.clipboard.writeText(copyText.value);
          copyText.type = 'hidden';
          processing.value = false;
          document.getElementById('share_link_cta').innerText = 'Copied !';
        }
        function forceRemount(section) {
          cartApp.unmount();

          let parser = new DOMParser();
          let doc = parser.parseFromString(section, 'text/html');
          document.getElementById('cart').innerHTML = doc.getElementById('cart').innerHTML;
          document.getElementById('cart').setAttribute('class', doc.getElementById('cart').getAttribute('class'));
          mountCartApp(company.value, vat.value);
        }
        async function HandleRemoveItem(key, id = null, skip_refresh = false, client_license = null) {
          if (id) {
            document.getElementById(`${id}`).classList.add('loading');
          }
          if (client_license && client_license != false && client_license != 'false') {
            const licenseFormData = {
              id: client_license,
              quantity: 0,
            };
            const licenseResponse = await fetch(window.Shopify.routes.root + 'cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(licenseFormData),
            });
            const licenseData = await licenseResponse.json();

            if (licenseData.message) {
              console.error(licenseData);
              return;
            }
          }

          const qtyFormData = {
            id: key,
            quantity: 0,
            sections: 'main-cart',
          };
          const qtyResponse = await fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(qtyFormData),
          });
          const qtyData = await qtyResponse.json();

          if (qtyData.message) {
            console.error(qtyData);
            if (id) {
              document.getElementById(`${id}`).classList.remove('loading');
            }
            return;
          }
          if (skip_refresh) {
            return;
          }
          const section = qtyData.sections['main-cart'];
          await nextTick();
          forceRemount(section);
        }
        async function HandleOrder(handles, license, size, font, license_name, client_license = null, action) {
          if (processing.value) {
            return;
          }

          if (!company.value) return;

          processing.value = true;

          if (client_license && client_license != false && client_license != 'false') {
            await HandleRemoveItem(client_license, null, true);
          }

          const products = JSON.parse(handles);
          const worker = 'https://lift-type-pam-gestion-licences.thisispam.workers.dev';

          const raw = JSON.stringify({
            license: license,
            products: products,
            company: company.value,
            size: size,
            vat: vat.value,
            font: font,
            license_name: license_name,
          });
          try {
            const response = await fetch(worker, {
              method: 'POST',
              redirect: 'follow',
              mode: 'cors',
              headers: {
                'Content-Type': 'application/json',
              },
              body: raw,
            });
            if (!response.ok) {
              throw new Error('Network response was not ok' + response.statusText);
            }
            const data = await response.json();
            if (data.data) {
              if (action == 'order') {
                await HandleAddToCart(data.data, null, null, true);
                window.location.href = window.Shopify.routes.root + 'checkout';
              } else {
                await HandleAddToCart(data.data);
                await nextTick();
                handleCopy(data.data);
              }
            } else {
              document.getElementById('error_order').style.display = 'block';
            }
            processing.value = true;
          } catch (error) {
            processing.value = false;
            console.error('There has been a problem with your fetch operation:', error);
          }
        }
        async function HandleAddToCart(id, item_to_remove = null, client_license = null, skip_refresh = false) {
          document.getElementById(`${id}`)?.classList.add('loading');

          if (item_to_remove && item_to_remove != false && item_to_remove != 'false') {
            await HandleRemoveItem(item_to_remove, null, true);
          }
          if (client_license && client_license != false && client_license != 'false') {
            await HandleRemoveItem(client_license, null, true);
          }

          //Update pour s'assurer d'avoir une quantity à 1
          let updates = {};
          updates[parseInt(id)] = 1;
          const qtyFormData = {
            updates,
            sections: 'main-cart',
          };
          const qtyResponse = await fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(qtyFormData),
          });
          const qtyData = await qtyResponse.json();

          if (qtyData.message) {
            console.error(qtyData);
            document.getElementById(`${id}`)?.classList.remove('loading');
            return;
          }
          if (skip_refresh) {
            return;
          }
          const section = qtyData.sections['main-cart'];
          await nextTick();
          forceRemount(section);
        }

        onMounted(() => {
          const selected = document.querySelector('.swiper-slide.selected');
          new Swiper('.main-cart .swiper', {
            loop: true,
            slidesPerView: 1.4,
            spaceBetween: 20,
            initialSlide: selected ? selected.getAttribute('data-index') : 0,
          });
        });

        return {
          company,
          vat,
          processing,
          handleCopy,
          forceRemount,
          HandleRemoveItem,
          HandleOrder,
          HandleAddToCart,
        };
      },
    });

    cartApp.mount('#cart');
  }

  mountCartApp();

  } catch(e) { console.error(e); }
})();
})();
